import type { VoidFunctionComponent } from 'react';

import Subnav from '../../generic/Subnav';

type NavKeys = 'settings' | 'rules';

type LicensePolicyPageSubnavProps = {
  policyId: number;
  activeKey: NavKeys;
};

export const LicensePolicyPageSubnav: VoidFunctionComponent<LicensePolicyPageSubnavProps> = ({
  policyId,
  activeKey,
}) => {
  return (
    <Subnav activeKey={activeKey}>
      <Subnav.Item to={`/policies/licensing/${policyId}`} navKey="rules">
        Licensing Rules
      </Subnav.Item>
      <Subnav.Item to={`/policies/licensing/${policyId}/settings`} navKey="settings">
        Settings
      </Subnav.Item>
    </Subnav>
  );
};
